export const TRAINING_EVENTS = {
  TRAINING_UPDATED: 'training_updated',
};
